var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#385cf8",
    stroke: "\\u2116385cf8",
    strokeWidth: "2px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.191,328.874a.959.959,0,0,0-1.352.1l-4.44,5.169-2.447-2.6a.959.959,0,1,0-1.4,1.316l3.178,3.371a.959.959,0,0,0,.7.3h.022a.959.959,0,0,0,.705-.334l5.134-5.977A.959.959,0,0,0,65.191,328.874Z",
    transform: "translate(-52.525 -323.901)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFilled);
export default __webpack_public_path__ + "static/media/check-filled.9a3d751ae50b4c5978ca84c33c3f55aa.svg";
export { ForwardRef as ReactComponent };